'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = eauors;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _ramda = require('ramda');

var _utils = require('../utils/');

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areaOver() {
  _d2.default.select(this.parentNode).style({ opacity: 0.8 });
}

function areaOut() {
  _d2.default.select(this.parentNode).style({ opacity: 1 });
}

function relevantAreasUpdate(selection, accessors, options, scale, base) {
  selection.on('mousemove', function (datum) {
    base.showTooltip(options, base, // stands for { xScale, yScale }
    null, // serie ... ?
    datum, options.colors[0]);
  }).on('mouseleave', (0, _ramda.curry)(base.hideTooltip)).on('mouseover', areaOver).on('mouseout', areaOut).style({
    fill: function fill(d) {
      return scale(accessors.value(d));
    }
  });
}

function labelEnter(selection, selectors) {
  (0, _utils.setupElement)(selection, 'svg:text', selectors.label);
}

function labelUpdate(selection, options, accessors, projection) {
  selection.text(accessors.label);
  selection.attr({
    x: function x(d) {
      var res = _d2.default.geo.path().projection(projection).centroid(d)[0];
      if (isNaN(res)) {
        return null;
      }
      return res;
    },
    y: function y(d) {
      var res = _d2.default.geo.path().projection(projection).centroid(d)[1];
      if (isNaN(res)) {
        return null;
      }
      return res;
    }
  });
  selection.style((0, _extends3.default)({}, (0, _utils.fontStyle)(accessors.labelFont(options)), {
    display: accessors.labelDisplay(options),
    'text-anchor': _constants.TEXT_MIDDLE
  }));
}

function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    relevantAreasUpdate: relevantAreasUpdate,
    labelEnter: labelEnter,
    labelUpdate: labelUpdate
  });
}